import moment from 'moment'
import * as R from 'ramda'
import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Modal } from 'semantic-ui-react'
import styled from 'styled-components'
import OmiseButton from '../../components/OmiseButton/index'
import { calculateTotalValue } from '../../containers/Payment/utils'
import { formatDateTime } from '../../utils/index'

const FullWidthButton = styled(Button)`
  width: 100%;
  max-width: 750px;
  min-height: 40px;
  max-height: 55px;
  height: 55px;
`

const descriptionType = {
  shirt: 'เสื้อวิ่งคอกลม',
  v_shirt: 'เสื้อวิ่งคอวี',
  undershirt: 'เสื้อกล้าม',
  buff: ''
}

export const SummaryParticipant = ({
  participant,
  raceDetail,
  selected_shirt,
  addons,
  handleSubmit,
  bankAccountModalOpen,
  toggleBankAccountModal,
  triggerOmiseForm,
  onPaypalSuccess,
  onOmiseSuccess
}) => {
  const overrideTextChoices = {
    shirt: 'override_addon_main_text',
    v_shirt: 'override_addon_main_text',
    undershirt: 'override_addon_undershirt_text',
    buff: 'override_addon_buff_text',
    keychain: 'override_addon_keychain_text'
  }
  const descriptionType = {
    shirt: 'เสื้อวิ่งคอกลม',
    v_shirt: 'เสื้อวิ่งคอวี',
    undershirt:
      R.path(['race_detail', 'race', 'id'], participant) === 20
        ? 'เสื้อวิ่งคอวี'
        : 'เสื้อกล้าม',
    buff: ''
  }
  return (
    <React.Fragment>
      <h1>รายการสมัครของฉัน</h1>
      <div className="ui grid">
        <div className="eight wide column">
          <h3>{R.path(['race_detail', 'race', 'title'], participant)}</h3>
          <p>
            {R.path(['race_detail', 'race', 'is_walk'], participant)
              ? 'จำนวนก้าว'
              : 'ระยะทาง'}
            :{R.path(['race_detail', 'distance', 'name'], participant)}
          </p>
          <p>
            ชื่อ:{' '}
            {participant.firstname
              ? `${participant.firstname} ${participant.lastname}`
              : participant.name}
          </p>
          {participant.engrave && <p>สลักชื่อ: {participant.engrave}</p>}
          <p>
            ที่อยู่: {participant.address_1} {participant.sub_district}{' '}
            {participant.district} {participant.province}{' '}
            {participant.postal_code}
          </p>
        </div>
        <div className="right aligned eight wide column">
          <div className="ui image">
            <img
              src={R.path(['race_detail', 'race', 'medal_image'], participant)}
              width="100"
              height="100"
            />
          </div>
        </div>
        <div className="sixteen wide column">
          <hr />
        </div>
        <div className="eight wide column">
          <p>ค่าสมัคร</p>
          {participant.addons &&
            participant.addons.map(each => (
              <p>
                {R.path(
                  [
                    'race_detail',
                    'race',
                    overrideTextChoices[R.path(['addon', 'type'], each)]
                  ],
                  participant
                ) || descriptionType[R.path(['addon', 'type'], each)]}{' '}
                {R.path(['addon', 'title'], each)}
              </p>
            ))}
        </div>
        <div className="right aligned eight wide column">
          <p>
            {R.path(['special'], participant) ? (
              <span>
                <s>{R.path(['race_detail', 'price'], participant)}</s>
                <span style={{ color: 'red', fontWeight: 'bold' }}>
                  {` ${R.path(
                    ['race_detail', 'special_price'],
                    participant
                  )} ฿`}
                </span>
              </span>
            ) : (
              <span>{`${R.path(
                ['race_detail', 'price'],
                participant
              )} ฿`}</span>
            )}{' '}
          </p>
          {participant.addons &&
            participant.addons.map(each => (
              <p>{R.path(['addon', 'price'], each)} ฿</p>
            ))}
        </div>
        <div className="sixteen wide column">
          <hr />
        </div>
        <div className="eight wide column">
          <p>ยอดรวมทั้งสิ้น</p>
        </div>
        <div className="right aligned eight wide column">
          <p>{calculateTotalValue(participant)} ฿</p>
        </div>
        <div className="eight wide column">
          <p>ค่าจัดส่ง</p>
        </div>
        <div className="right aligned eight wide column">
          <p>ฟรี</p>
        </div>
        <div className="sixteen wide column" style={{ textAlign: 'center' }}>
          <hr />
          วัน/เวลาที่สมัคร :{' '}
          {moment(participant.created).format('DD/MM/YYYY HH:mm:ss')}
          <hr />
        </div>
        {!participant.is_paid && (
          <div className="sixteen wide column">
            <h3>เลือกช่องทางการชำระเงิน</h3>
            <div style={{ marginBottom: '10px' }}>
              <div style={{ marginBottom: '10px', textAlign: 'center' }}>
                <OmiseButton
                  {...participant}
                  targetId={participant.id}
                  amount={calculateTotalValue(participant)}
                  onSuccess={onOmiseSuccess}
                  type="participants"
                />
              </div>
              <div style={{ marginBottom: '10px', textAlign: 'center' }}>
                <FullWidthButton onClick={toggleBankAccountModal} color="teal">
                  โอนเงินผ่านธนาคาร
                </FullWidthButton>
              </div>
              {!participant.is_paid && (
                <div style={{ marginBottom: '10px', textAlign: 'center' }}>
                  <Link to={`/participants/${participant.id}/edit`}>
                    <FullWidthButton
                      color="orange"
                      style={{ backgroundColor: 'rgb(255, 204, 0)' }}
                    >
                      แก้ไขคำสั่งซื้อ
                    </FullWidthButton>
                  </Link>
                </div>
              )}
              <div style={{ marginBottom: '10px', textAlign: 'center' }}>
                <h3>
                  ชำระภายใน{' '}
                  {formatDateTime(moment(participant.created).add(2, 'days'))}{' '}
                  21:49
                </h3>
              </div>
              {/* <PaypalButton
            onSuccess={onPaypalSuccess}
            value={calculateTotalValue(participant)}
          /> */}
            </div>
          </div>
        )}
      </div>
      <Modal
        open={bankAccountModalOpen}
        closeOnDimmerClick
        onClose={toggleBankAccountModal}
      >
        <Modal.Header>บัญชีธนาคาร</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <p>ชื่อบัญชี: บริษัท เอ เซอเพนส์ จำกัด</p>
            <p>ธนาคารไทยพาณิชย์ สาขาเซ็นทรัลพลาซ่า เวสต์เกต</p>
            <p>เลขบัญชี: 468-075-836-0</p>
            <p style={{ fontSize: 14 }}>
              *หลังจากโอนเงินแล้วกรุณาแนบหลักฐานการโอนเงินด้วย
            </p>
            <Button onClick={toggleBankAccountModal}>กลับสู่หน้าหลัก</Button>
            <Link to="/confirm-payment">
              <Button color="teal">คลิ๊กที่นี่เพื่อแนบหลักฐานการโอนเงิน</Button>
            </Link>
          </Modal.Description>
        </Modal.Content>
      </Modal>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// /opt/build/repo/src/organisms/SummaryParticipant/index.js